var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 18,
  width: 7,
  height: 7,
  rx: 1.2,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 18,
  width: 7,
  height: 7,
  rx: 1.2,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 8,
  width: 7,
  height: 7,
  rx: 1.2,
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjgiIHk9IjE4IiB3aWR0aD0iNyIgaGVpZ2h0PSI3IiByeD0iMS4yIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgIDxyZWN0IHg9IjE4IiB5PSIxOCIgd2lkdGg9IjciIGhlaWdodD0iNyIgcng9IjEuMiIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cmVjdCB4PSIxOCIgeT0iOCIgd2lkdGg9IjciIGhlaWdodD0iNyIgcng9IjEuMiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { Svg32 as ReactComponent };